import React from "react";
import { Box, Typography } from "@mui/material";
import {
  formatDateOnlyDay,
  formatDateOnlyMouth,
  formatDateOnlyYear,
  unixToDateOnlyDay,
  unixToDateOnlyMouth,
  unixToDateOnlyYear,
} from "../../utils/date-converter";

const DateWithUnderline = ({ created_date, documentType }) => {
  console.log("documentType", documentType);
  return (
    <>
      {created_date && (
        <Box gap={1.25} display="flex">
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 400,
              ml: documentType === "manufacture_order" ? "4px" : "0",
            }}
          >
            {typeof created_date === "number"
              ? unixToDateOnlyDay(created_date)
              : formatDateOnlyDay(created_date)}
          </Typography>
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 400,
              ml: documentType === "manufacture_order" ? "3px" : "8px",
            }}
          >
            {typeof created_date === "number"
              ? unixToDateOnlyMouth(created_date)
              : formatDateOnlyMouth(created_date)}
          </Typography>
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 400,
              ml: documentType === "manufacture_order" ? "2px" : "6px",
            }}
          >
            {typeof created_date === "number"
              ? unixToDateOnlyYear(created_date)
              : formatDateOnlyYear(created_date)}
          </Typography>
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          mt: created_date ? -2 : "38px",
          color: "#BDBDBD",
          fontSize: 12,
        }}
      >
        <Box
          sx={{
            width: documentType === "manufacture_order" ? 20 : 26,
            borderBottom: "1px solid #BDBDBD",
          }}
        />
        /
        <Box
          sx={{
            width: documentType ? 20 : 26,
            borderBottom: "1px solid #BDBDBD",
          }}
        />
        /
        <Box
          sx={{
            width: documentType ? 30 : 40,
            borderBottom: "1px solid #BDBDBD",
          }}
        />
      </Box>
    </>
  );
};

export default DateWithUnderline;
